import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash-es';
import { waitForRenderThenFocus } from '../../../../../utilities/ui/focus';

const ProfileMenuButton = ({
  profile,
  expanded,
  setExpanded,
  setFocusedIndex,
}) => {
  const focusFirstItem = () => {
    waitForRenderThenFocus('#nav__user-list li:first-child', document, 50, 'a');
    setFocusedIndex(0);
  };

  const focusLastItem = () => {
    waitForRenderThenFocus('#nav__user-list li:last-child', document, 50, 'a');
    setFocusedIndex(
      document.querySelector('#nav__user-list').childNodes.length - 1,
    );
  };

  const handleKeyDown = event => {
    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        setExpanded(prev => !prev);
        break;
      case 'ArrowDown':
        event.preventDefault();
        setExpanded(true);
        focusFirstItem();
        break;
      case 'ArrowUp':
        event.preventDefault();
        setExpanded(true);
        focusLastItem();
        break;
      case 'Escape':
      case 'Tab':
        setExpanded(false);
        break;
      default:
        break;
    }
  };

  const firstName = profile?.firstName ?? '';
  const lastName = profile?.lastName ?? '';
  const fullNameLabel =
    startCase(`${firstName} ${lastName}`.trim().toLowerCase()) || 'Account';

  return (
    <>
      {/* eslint-disable-next-line @department-of-veterans-affairs/prefer-button-component */}
      <button
        className="nav__btn nav__btn--user vads-u-color--base arp-profile-dropdown"
        aria-controls="nav__user"
        aria-label={fullNameLabel}
        aria-expanded={expanded}
        aria-haspopup="true"
        onClick={() => setExpanded(prev => !prev)}
        onKeyDown={handleKeyDown}
        type="button"
        data-testid="profile-menu"
      >
        <va-icon icon="account_circle" size="2" class="nav__user-btn-icon" />
        <span className="nav__btn--user-name desktop">{fullNameLabel}</span>
        <span className="nav__btn--user-name mobile">
          {startCase(firstName.toLowerCase()) || 'Account'}
        </span>
        <va-icon icon="chevron_left" size="1" class="user-nav__chevron" />
      </button>
    </>
  );
};

ProfileMenuButton.propTypes = {
  expanded: PropTypes.bool,
  profile: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  setExpanded: PropTypes.func,
  setFocusedIndex: PropTypes.func,
};

export default ProfileMenuButton;
